import styles from './css/SideMenuGroupItem.module.scss'
import React from "react"
import { AuthContext } from "@providers/AuthProvider"
import { LinkContainer } from 'react-router-bootstrap'
import { ModuleIdEnum } from 'cs.node.utils/csapi/provisioning'
import { UserRoleEnum } from 'cs.node.utils/RoleUtils'

type Props = {
    name: string,
    to: string,
    selected: Boolean
    modules?: (keyof typeof ModuleIdEnum)[]
    roles?: (keyof typeof UserRoleEnum)[]
}

const SideMenuGroupItem = (props:Props) =>{
    const auth = React.useContext(AuthContext)
    const { name, to, selected, roles, modules } = props

    // check if the user has access to at least one of the modules listed in the modules property
    const modulesNotAllowed = modules && !auth.userData.modules?.find(module=>{
        return module._id && modules.includes(module._id) && module.enabled
    })

    // check if the user has the role needed for this page
    const roleNotAllowed = !roles || !roles.includes(auth.userData.role)

    if(modulesNotAllowed || roleNotAllowed) return <></>

    return (
        <div className={`${styles.container} ${selected?styles.selected:''}`}>
            <div className={`${styles.bullet} ${selected?styles.selected:''}`}>
                <LinkContainer to={to} style={{fontWeight: '500', fontSize: '1.10rem', textDecoration: 'none'}}>
                    <a href={to}>
                        <span role="button" className={`${selected?"text-primary":"text-gray-700"} text-decoration-none`} >
                            {name}
                        </span>
                    </a>
                </LinkContainer>
            </div>
        </div>
    )
}

export default SideMenuGroupItem